import { render, staticRenderFns } from "./covert_face_detail_form.vue?vue&type=template&id=2830d085"
import script from "./covert_face_detail_form.vue?vue&type=script&lang=js"
export * from "./covert_face_detail_form.vue?vue&type=script&lang=js"
import style0 from "./covert_face_detail_form.vue?vue&type=style&index=0&id=2830d085&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports